module.exports = __webpack_public_path__ + "img/fred.b0446d65.png";